import {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import ReactGA from "react-ga4";
import PropTypes from 'prop-types';

const version = process.env.REACT_APP_VERSION;
const deployment = process.env.REACT_APP_DEPLOYMENT;
const env = process.env.REACT_APP_NODE_ENV;


const GACmp = ({trackingIds}) => {
  const location = useLocation();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (!initialized) {
      ReactGA.initialize(trackingIds?.map(trackingId => {
        return {
          trackingId,
        }
      }));
      ReactGA.set({
        env,
        version,
        deployment
      })
      setInitialized(true);
    } else {
      console.log('sending', location.pathname + location.search)
      ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
    }

  });

  return null;
}

GACmp.propTypes = {
  trackingIds: PropTypes.array,
};

GACmp.defaultProps = {
  trackingIds: []
};

export default GACmp;
